var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadingTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#a4c0c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.92,108.7V20.32a8,8,0,0,0-8-8H68.84a8,8,0,0,0-8,8V108.7a47.86,47.86,0,1,0,72.08,0Zm-36,63.35a31.86,31.86,0,0,1-22.41-54.5,8,8,0,0,0,2.37-5.69V28.32h40.08V53H100a8,8,0,0,0,0,16h16.92V82.68H100a8,8,0,0,0,0,16h16.92v13.18a8,8,0,0,0,2.37,5.69,31.86,31.86,0,0,1-22.41,54.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingTemperature);
export default __webpack_public_path__ + "static/media/Reading - Temperature.e78fc7dd7d6ee2e0029731f493b3f66a.svg";
export { ForwardRef as ReactComponent };